// extracted by mini-css-extract-plugin
export default {"profileVedio":"index_profileVedio_vF6Fy","profileVediobg":"index_profileVediobg_1Gvdx"};